import React, { useState } from "react";
import {
  Typography,
  Collapse,
  IconButton,
  Card,
  CardContent,
  Box,
  Container,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ScrollToTopButton from "./Utilities/ScrollToTopButton";
import { Helmet } from "react-helmet-async";

const faqs = [
  {
    question: "How long does it take to receive money after making a withdrawal?",
    answer:
      "Withdrawal processing usually takes a few hours to 24 hours on our end. However, the final time may vary depending on your payment method and banking system.",
  },
  {
    question: "What is the minimum amount I can withdraw?",
    answer:
      "The minimum withdrawal amount depends on your account type and payment method, but it is generally kept low to ensure flexibility for traders.",
  },
  {
    question: "Which payment methods can I use to make deposits and withdrawals?",
    answer:
      "We support multiple payment methods including bank transfers, UPI, debit/credit cards, and other secure online payment options.",
  },
  {
    question: "Are there any fees for deposits or withdrawals?",
    answer:
      "We do not charge any fees for deposits or withdrawals. All transactions are processed without additional platform charges.",
  },
  {
    question: "How long does it take for deposits to reflect in my account?",
    answer:
      "Deposits are usually processed instantly or within a few minutes. In some cases, it may take a few hours depending on the payment provider.",
  },
  {
    question: "Can I withdraw funds to a different account than I deposited from?",
    answer:
      "For security reasons, withdrawals are generally processed back to the original payment method used for deposits.",
  },
  {
    question: "Is verification required before making a withdrawal?",
    answer:
      "Yes, account verification (KYC) is required before processing withdrawals to ensure compliance and security.",
  },
  {
    question: "What should I do if my withdrawal is delayed?",
    answer:
      "If your withdrawal takes longer than expected, you can check your account status or contact customer support for assistance.",
  },
  {
    question: "Are there any limits on deposits or withdrawals?",
    answer:
      "A minimum limit may apply, but there is no maximum limit on deposits or withdrawals",
  },
  {
    question: "Is it safe to deposit funds on the platform?",
    answer:
      "Yes, all transactions are secured with advanced encryption and trusted payment gateways to ensure safe fund transfers.",
  },
];

const DepositWithdrawalfaq = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
        <>
        <Helmet>
            <link rel="canonical" href="https://www.hcfinvest.com/copyTradingfaq" />
          </Helmet>
    <Container sx={{ backgroundColor: "#fff" }} maxWidth={false} disableGutters>
        <ScrollToTopButton/>
      <Box
        sx={{
          position: "relative",
          height: "475px",
          display: "flex",
          flexDirection: "column", // 👈 Stack text vertically
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          backgroundImage: `url('Images/HelpCenterImages/Newhedgecapitalsimage_Helpcenter 1.jpg')`, // 👈 replace with your image path
          backgroundSize: "cover",
          backgroundPosition: "center",
          marginBottom: "30px",
          textAlign: "center",
        }}
      >
        <h1
          // variant="h3"
          // component="h1"
          sx={{
            zIndex: 2,
            fontWeight: 600,
            textAlign: "center",
            px: 2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          Deposits And Withdrawals
        </h1>

        <h3
          // variant="h5"
          sx={{
            zIndex: 2,
            fontWeight: 600,
            textAlign: "center",
            px: 2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          Manage Your Funds with Ease and Confidence
        </h3>
      </Box>

      <Typography
        variant="h2"
        sx={{
          marginBottom: "50px",
          fontWeight: "600",
          fontSize: "2.5rem",
          color: "#101828",
        }}
      >
        FAQ
      </Typography>

      <Box sx={{ maxWidth: "1200px", margin: "40px auto" }}>
        {faqs.map((faq, index) => (
          <Card
            key={index}
            sx={{
              mb: 2,
              boxShadow: 2,
              borderRadius: 2,
              backgroundColor: "#fff",
              cursor: "pointer",
            }}
            onClick={() => handleToggle(index)}
          >
            <CardContent>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography variant="h6" fontWeight="bold">
                  {faq.question}
                </Typography>
                <IconButton>
                  <ExpandMoreIcon
                    sx={{
                      transform:
                        openIndex === index ? "rotate(180deg)" : "rotate(0deg)",
                      transition: "transform 0.3s ease",
                    }}
                  />
                </IconButton>
              </Box>

              <Collapse in={openIndex === index} timeout="auto" unmountOnExit>
                <Typography
                  variant="body1"
                  sx={{
                    mt: 2,
                    color: "text.secondary",
                    lineHeight: 1.7,
                    textAlign: "left",
                  }}
                >
                  {faq.answer}
                </Typography>
              </Collapse>
            </CardContent>
          </Card>
        ))}
      </Box>
    </Container>

        </>
          );
};

export default DepositWithdrawalfaq;
